module.exports = __webpack_public_path__ + "img/雨夹雪.25491902.png";